const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 17.0095V10.9995C16 10.4495 15.55 9.99953 15 9.99953C14.45 9.99953 14 10.4495 14 10.9995V17.0095H12.21C11.76 17.0095 11.54 17.5495 11.86 17.8595L14.65 20.6395C14.85 20.8295 15.16 20.8295 15.36 20.6395L18.15 17.8595C18.47 17.5495 18.24 17.0095 17.8 17.0095H16ZM8.65003 3.34953L5.86003 6.13953C5.54003 6.44953 5.76003 6.98953 6.21003 6.98953H8.00003V12.9995C8.00003 13.5495 8.45003 13.9995 9.00003 13.9995C9.55003 13.9995 10 13.5495 10 12.9995V6.98953H11.79C12.24 6.98953 12.46 6.44953 12.14 6.13953L9.35003 3.34953C9.16003 3.15953 8.84003 3.15953 8.65003 3.34953Z",
  fill: "url(#paint0_linear)"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 5.16639,
  y1: -3.21744,
  x2: 18.8243,
  y2: -3.13239,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.122751,
  stopColor: "#0F62FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6B5BD2"
})));
function SvgTrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.2f8461a6fc9114d4fce38194bc7cbcf8.svg";
export { ForwardRef as ReactComponent };